module.exports = __webpack_public_path__ + "32f1dcdfbf170472b66b53a6cb0fac0b.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/common/communication.png
// module id = 2050
// module chunks = 0